module.exports = __webpack_public_path__ + "img/icon_benefit_08.2712a2fc.svg";